import { truncateToCodePointLimit } from '@shared/stringUtils';

const ROC_FILE_NAME_DISALLOWED = /[\x00-\x1f/\\]/g;

export function sanitizeRocFileName(fileName: string): string {
  const sanitized = fileName
    .trim()
    .replace(ROC_FILE_NAME_DISALLOWED, '_')
    .replace(/^\.+/, '_');

  return truncateToCodePointLimit(sanitized || 'document', 255);
}
